import {
  hero as baseHero,
  quickLinks,
  about,
  stats,
  directions,
  review,
  newsBlock,
  advantages,
} from '../homeRedesignData'

import heroBuildingA from '@/assets/img/home-redesign/hero-building-a.jpg'

export const heroActions = [
  // Временно скрыто: кнопка записи пока не функциональна
  // { label: 'Записаться на приём', to: '/paid-services', primary: true },
  { label: 'О центре', to: '/about', primary: false },
]

export const heroA = {
  ...baseHero,
  titleLine1: 'Перинатальный центр',
  titleBrand: 'ДАР',
  description: 'КГБУЗ «Алтайский краевой клинический перинатальный центр»',
  actions: heroActions,
  image: heroBuildingA,
}

export const heroB = {
  ...baseHero,
  titleLine1: 'Перинатальный центр',
  titleBrand: 'ДАР',
  subtitle: 'КГБУЗ «Алтайский краевой клинический перинатальный центр»',
  description:
    'Помощь женщине и ребёнку на всех этапах — от планирования беременности до первых дней жизни малыша.',
  actions: heroActions,
}

export const heroC = {
  ...baseHero,
  titleLine1: 'Перинатальный центр',
  titleBrand: 'ДАР',
  description:
    'Современная помощь женщине и ребёнку на всех этапах — от планирования беременности до первых дней жизни малыша.',
  actions: heroActions,
}

export const heroStatsA = [
  { value: '—', label: 'ребенка родилось в нашем центре', field: 'countOpen' },
  { value: '—', label: 'родов в этом году', field: 'countStartYear' },
  { value: '—', label: 'заботы и помощи семьям', field: 'yearsOfCare', kind: 'yearsOfCare' },
  {
    value: '—',
    label: 'оценка пациентов на 2ГИС',
    kind: 'rating2gis',
  },
]

export {
  quickLinks,
  about,
  stats,
  directions,
  review,
  newsBlock,
  advantages,
}
